<div class="proximity-container">
  <!-- Header -->
  <div class="proximity-header">
    <div class="header-info">
      <h2>📡 Proximidad</h2>
      <div class="connection-status" [class.connected]="isConnected">
        <span class="status-dot"></span>
        {{ isConnected ? 'Conectado' : 'Desconectado' }}
      </div>
    </div>

    <div class="proximity-toggle">
      <button 
        class="toggle-btn"
        [class.enabled]="settings.enabled"
        [disabled]="isLoading || !isConnected"
        (click)="toggleProximity()">
        <span class="toggle-icon">
          {{ settings.enabled ? '📡' : '📴' }}
        </span>
        <span class="toggle-text">
          {{ settings.enabled ? 'Desactivar' : 'Activar' }}
        </span>
        <div class="spinner" *ngIf="isLoading"></div>
      </button>
    </div>
  </div>

  <!-- Settings Panel -->
  <div class="settings-panel" *ngIf="settings.enabled">
    <div class="setting-row">
      <label for="radius">Radio de detección:</label>
      <div class="radius-control">
        <input 
          type="range" 
          id="radius"
          min="100" 
          max="5000" 
          step="100"
          [value]="settings.radiusMeters"
          (input)="updateRadius($event)">
        <span class="radius-value">{{ settings.radiusMeters }}m</span>
      </div>
    </div>

    <div class="quick-actions">
      <button 
        class="action-btn primary"
        [disabled]="isLoading || nearbyUsers.length === 0"
        (click)="joinProximityChat()">
        💬 Chat de Proximidad
      </button>
      
      <button 
        class="action-btn secondary"
        [disabled]="isLoading"
        routerLink="/chat">
        🗨️ Ver Chats Activos
      </button>
    </div>
  </div>

  <!-- Nearby Users List -->
  <div class="nearby-users" *ngIf="settings.enabled">
    <div class="users-header">
      <h3>👥 Usuarios Cercanos</h3>
      <span class="users-count">({{ nearbyUsers.length }})</span>
    </div>

    <div class="users-list" *ngIf="nearbyUsers.length > 0">
      <div 
        *ngFor="let user of nearbyUsers" 
        class="user-card"
        [class.new-detection]="user.isNewDetection">
        
        <div class="user-info">
          <div class="user-header">
            <div class="user-name">
              {{ user.userInfo.name }}
              <span class="validation-icon">
                {{ getUserValidationIcon(user.userInfo.validation_level) }}
              </span>
            </div>
            <div class="user-distance">
              {{ formatDistance(user.distance) }}
            </div>
          </div>

          <div class="user-details">
            <div class="user-reputation">
              {{ getReputationStars(user.userInfo.reputation) }}
            </div>
            <div class="user-last-seen">
              {{ formatLastSeen(user.lastSeen) }}
            </div>
          </div>

          <div class="user-type">
            <span class="app-type-badge">
              {{ user.userInfo.app_type }}
            </span>
          </div>
        </div>

        <div class="user-actions">
          <button class="action-btn small" disabled>
            👋 Saludar
          </button>
        </div>
      </div>
    </div>

    <!-- No users found -->
    <div class="no-users" *ngIf="nearbyUsers.length === 0 && settings.enabled">
      <div class="no-users-content">
        <div class="no-users-icon">🔍</div>
        <h4>No hay usuarios cercanos</h4>
        <p>No se encontraron otros usuarios en un radio de {{ settings.radiusMeters }}m.</p>
        <p>Intenta aumentar el radio de búsqueda o cambia de ubicación.</p>
      </div>
    </div>
  </div>

  <!-- Disabled State -->
  <div class="proximity-disabled" *ngIf="!settings.enabled">
    <div class="disabled-content">
      <div class="disabled-icon">📴</div>
      <h3>Proximidad Desactivada</h3>
      <p>Activa las notificaciones de proximidad para descubrir otros usuarios cerca de ti y unirte a chats locales.</p>
      
      <div class="disabled-features">
        <div class="feature-item">
          <span class="feature-icon">💬</span>
          <span class="feature-text">Chat con usuarios cercanos</span>
        </div>
        <div class="feature-item">
          <span class="feature-icon">📍</span>
          <span class="feature-text">Detección en tiempo real</span>
        </div>
        <div class="feature-item">
          <span class="feature-icon">🔔</span>
          <span class="feature-text">Notificaciones automáticas</span>
        </div>
      </div>

      <button 
        class="enable-btn"
        [disabled]="isLoading || !isConnected"
        (click)="toggleProximity()">
        <span *ngIf="!isLoading">📡 Activar Proximidad</span>
        <span *ngIf="isLoading">
          <div class="spinner inline"></div>
          Activando...
        </span>
      </button>
    </div>
  </div>

  <!-- Connection Error -->
  <div class="connection-error" *ngIf="!isConnected">
    <div class="error-content">
      <div class="error-icon">⚠️</div>
      <h4>Sin Conexión</h4>
      <p>No hay conexión con el servidor. Las funciones de proximidad no están disponibles.</p>
    </div>
  </div>
</div>